<ng-container *ngIf="authorizedData$ | async as authorizedData; else loadingTemplate">
  <header class="header"></header>

  <div class="d-flex flex-column mx-auto p-4 p-md-0 pt-md-8 pb-md-5 content">
    <div class="d-flex flex-column flex-md-row">
      <div class="d-flex flex-column flex-1">
        <div *ngIf="user$ | async as user" class="d-flex align-items-center">
          <img [src]="user.picture || 'assets/icons/avatar.svg'" alt="user" class="picture" />

          <div class="d-flex flex-column ml-4 text-ellipsis">
            <h2 class="semi-bold">
              Hi,
              @if (user.fullname) {
                <span data-id="user-fullname">{{ user.fullname }}</span>
              } @else {
                traveler
              }
            </h2>
            <p data-id="user-email">{{ user.email }}</p>
          </div>
        </div>

        <wallet-balance
          [clientBalanceAmount]="authorizedData?.clientBalanceAmount || 0"
          [creditBreakdown]="authorizedData?.creditBreakdown || []"
          class="mt-4"
        />
      </div>

      <div class="d-none d-md-flex flex-1">
        <start-planning-card (startPlanning)="startPlanning()" />
      </div>
    </div>

    @if (referralProgram$ | async; as referralProgram) {
      @if (referralProgram.isEligible) {
        <referral-home-banner [program]="referralProgram" class="mt-6 mt-md-8" />
      }
    }

    @let orders = authorizedData.upcomingFlightOrders?.edges;
    <ng-container *ngIf="orders?.length">
      <h2 class="d-md-none semi-bold mt-6">Upcoming trips</h2>
      <h1 class="d-none d-md-inline semi-bold mt-8">Upcoming trips</h1>

      @for (order of orders; track order) {
        @let node = order.node;
        @let departureAirport = node?.flightItineraries?.[0]?.departureAirport;
        @let departureAt = node?.flightItineraries?.[0]?.departureAt;
        @let totalPassengers = node?.totalPassengers;
        @let arrivalAirport = node?.flightItineraries?.[0]?.arrivalAirport;
        @let type = node?.tripType;

        <a [routerLink]="[PortalRoutes.Trips, node.portalLink]" class="mt-4 mt-md-5 link">
          <trip-item
            [departureAirport]="departureAirport"
            [departureAt]="departureAt"
            [tripType]="type"
            [totalPassengers]="totalPassengers"
            [arrivalAirport]="arrivalAirport"
            [inplace]="true"
          />
        </a>
      }
    </ng-container>

    <ng-container *ngIf="authorizedData.quotes?.length">
      <h2 class="d-md-none semi-bold mt-6">Your active flight quotes</h2>
      <h1 class="d-none d-md-inline semi-bold mt-8">Your active flight quotes</h1>

      @for (portalLead of authorizedData.quotes; track portalLead) {
        @let departureAirport = portalLead.firstTrip?.departureAirport;
        @let departureAt = portalLead.firstTrip?.departureAt;
        @let totalPassengers = portalLead.firstTrip?.passengerCount;
        @let arrivalAirport = portalLead.firstTrip?.arrivalAirport;
        @let tripType = portalLead.tripType;
        @let roundTripDepartureAt = portalLead.roundTripDepartureAt;
        @let minimalOptionPrice = portalLead.minimalOptionPrice;
        @let optionCount = portalLead.optionCount;
        @let maximalSecureSavings = portalLead.maximalSecureSavings;

        <a [routerLink]="[portalLead.portalLink]" class="mt-4 mt-md-5 link">
          <trip-item
            [departureAirport]="departureAirport"
            [departureAt]="departureAt"
            [totalPassengers]="totalPassengers"
            [arrivalAirport]="arrivalAirport"
            [tripType]="tripType"
            [roundTripDepartureAt]="roundTripDepartureAt"
            [minimalOptionPrice]="minimalOptionPrice"
            [maximalSecureSavings]="maximalSecureSavings"
            [optionCount]="optionCount"
          />
        </a>
      }
    </ng-container>

    <div class="d-md-none mt-6">
      <start-planning-card (startPlanning)="startPlanning()" />
    </div>

    <need-help-card class="mt-6 mt-md-8" />
  </div>

  <footer></footer>
</ng-container>

<ng-template #loadingTemplate>
  <home-loading-page />
</ng-template>

<ng-template #startPlanningTemplate>
  <div>hello world</div>
</ng-template>

<ng-template #tripPlanningModal>
  <planning-trip-modal [model]="nextTripModel" />
</ng-template>
